/* DoodleBeast: turn colour option pills (without swatch metafields) into colour circles */
(function () {
  var MAP = {
    'black': '#141414', 'zwart': '#141414',
    'white': '#ffffff', 'wit': '#ffffff', 'spierwit': '#ffffff',
    'orange': '#FF8A00', 'oranje': '#FF8A00',
    'lavander': '#AC66CC', 'lavender': '#AC66CC', 'lavendel': '#AC66CC', 'lila': '#AC66CC',
    'bright green': '#C9F80D', 'green': '#5BC236', 'groen': '#5BC236', 'felgroen': '#C9F80D', 'heldergroen': '#C9F80D',
    'pink': '#F7A8BA', 'roze': '#F7A8BA',
    'yellow': '#FFE500', 'geel': '#FFE500',
    'ice blue': '#98BEF0', 'ijsblauw': '#98BEF0', 'lichtblauw': '#98BEF0', 'blue': '#2D5BE3', 'blauw': '#2D5BE3',
    'gold': '#E4BD68', 'goud': '#E4BD68',
    'beige': '#F7E6DE',
    'magenta': '#EC008C',
    'turquoise': '#00B1B7', 'turkoois': '#00B1B7',
    'red': '#E63946', 'rood': '#E63946',
    'grey': '#9A9A9A', 'gray': '#9A9A9A', 'grijs': '#9A9A9A',
    'silver': '#C9CCD1', 'zilver': '#C9CCD1'
  };
  var LEGEND = { 'kleur carrosserie': 'Kleur', 'body color': 'Kleur', 'base color': 'Basiskleur', 'basiskleur': 'Basiskleur', 'finish': 'Finish' };
  function apply(root) {
    (root || document).querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      var firstText = legend.childNodes[0];
      if (firstText && firstText.nodeType === 3) {
        var raw = firstText.nodeValue.replace(/[:\s]+$/, '').trim().toLowerCase();
        if (LEGEND[raw]) firstText.nodeValue = LEGEND[raw] + (firstText.nodeValue.indexOf(':') > -1 ? ': ' : '');
      }
      if (!fs.classList.contains('product-form__input--pill')) return;
      var name = legend.textContent.trim().toLowerCase();
      if (!/(base|basis|body|kleur|colou?r)/.test(name)) return;
      var labels = fs.querySelectorAll('input[type=radio] + label');
      var hits = 0;
      labels.forEach(function (l) {
        var key = (l.childNodes[0] && l.childNodes[0].nodeType === 3 ? l.childNodes[0].nodeValue : l.textContent).trim().toLowerCase().replace(/\s+/g, ' ');
        var hex = MAP[key];
        if (!hex) { Object.keys(MAP).some(function (k) { if (key.indexOf(k) === 0) { hex = MAP[k]; return true; } return false; }); }
        if (hex) { l.style.setProperty('--db-swatch', hex); hits++; }
      });
      if (hits >= Math.max(1, labels.length / 2)) fs.classList.add('db-color-pill');
    });
  }
  apply();
  document.addEventListener('DOMContentLoaded', function () { apply(); });
  var obs = new MutationObserver(function () { apply(); });
  var target = document.querySelector('product-info') || document.body;
  obs.observe(target, { childList: true, subtree: true });
})();
